import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Optional, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { FormState, FormValidationService } from 'services/form-validation.service';

@Component({
	selector: 'submit-button',
	templateUrl: 'submit-button.component.html',
	imports: [NgClass, TranslatePipe]
})
export class SubmitButtonComponent implements OnDestroy {

	@Input() label = '';
	@Input() labelSaved?: string;
	@Input() progression?: { processed: number, total: number };
	@Input() type = 'confirm';
	@Input() working = false;
	/**
	 * Callback method that can be used instead of click event to let the button itself handle feedback on success and error states
	 */
	@Input() asyncCallback?: () => Promise<any> | undefined;

	private _ignoreValidation = false;
	private formSubmitSubscription?: Subscription;
	@Output('click') click = new EventEmitter<void>();
	@Input()
	set ignoreValidation(value: boolean) {
		this._ignoreValidation = value;
		this.updateStateClass();
	}
	get ignoreValidation() {
		return this._ignoreValidation;
	}

	private _active = true;
	@Input()
	set active(value: boolean) {
		this._active = value;
		this.updateStateClass();
	}
	get active() {
		return this._active;
	}

	public stateClass = 'disabled';
	private state: FormState = FormState.Pristine;

	constructor(@Optional() private formValidation: FormValidationService, @Optional() private form: NgForm) {
		if (this.form) this.formSubmitSubscription = this.form.ngSubmit.subscribe((event: SubmitEvent) => {
			if (this.parseClick(event)) this.click.next();
		});
		if (formValidation != null) {
			formValidation.stateChanged.subscribe(state => {
				this.state = state;
				setTimeout(() => { this.updateStateClass(); });
			});
		}
	}
	ngOnDestroy(): void {
		if (this.formSubmitSubscription) this.formSubmitSubscription.unsubscribe();
	}

	private updateStateClass() {
		if (!this.active)
			this.stateClass = 'disabled';
		else if (this.ignoreValidation)
			this.stateClass = 'valid';
		else
			switch (this.state) {
				case FormState.Invalid:
					this.stateClass = 'invalid';
					break;
				case FormState.Valid:
					this.stateClass = 'valid';
					break;
				case FormState.Pristine:
					this.stateClass = 'disabled';
					break;
				case FormState.Saved:
					this.stateClass = 'saved';
					break;
			}
	}


	parseClick(event: Event): boolean {
		if ((this.state !== FormState.Valid && !this.ignoreValidation) || !this.active || this.working) {
			event.stopPropagation();
			return false;
		}
		this.working = true;

		if (this.asyncCallback) this.asyncCallback()?.then(() => this.succeeded()).catch(() => this.reset());

		return true;
	}

	showSaved(): boolean {
		if (!this.labelSaved) return false;
		return (this.state === FormState.Saved);
	}

	public succeeded(): void {
		this.working = false;
		this.progression = undefined;
		if (this.formValidation != null) this.formValidation.saved();
		else this.state = FormState.Saved;
	}

	public reset(): void {
		this.working = false;
		this.progression = undefined;
		if (this.formValidation != null) this.formValidation.reset();
		else this.state = FormState.Valid;
	}

}
